import { z } from 'zod'

export const MAX_POLLING_FREQUENCY_DAYS = 30
export const MAX_POLLING_FREQUENCY_HOURS = 720
export const MAX_POLLING_FREQUENCY_MINUTES = 60

export const isValidPollingFrequency = (value: number | undefined, unit: string): boolean => {
  if (value === undefined || value === null || value <= 0) {
    return false
  }
  if (unit === 'minutes') {
    return value <= MAX_POLLING_FREQUENCY_MINUTES
  }
  if (unit === 'hours') {
    return value <= MAX_POLLING_FREQUENCY_HOURS
  }
  if (unit === 'days') {
    return value <= MAX_POLLING_FREQUENCY_DAYS
  }
  return false
}

export const PollingFrequencyUnitSchema = z.enum(['minutes', 'hours', 'days'])
export type PollingFrequencyUnit = z.infer<typeof PollingFrequencyUnitSchema>

const PollingFrequencySchema = z.object({
  value: z
    .number()
    .int()
    .positive()
    .describe('Polling interval value. Max 720 hours or 30 days. Must be a positive integer.')
    .optional(),
  unit: PollingFrequencyUnitSchema,
})

export const PollingConfigurationSchema = z.object({
  enabled: z.boolean(),
  frequency: PollingFrequencySchema,
  property: z.string().min(1).describe('JSON path to extract from the response (e.g., "$.status" or "ticket.status")'),
  value: z
    .array(z.string().min(1))
    .optional()
    .describe('Expected values that will complete the block when found (e.g., ["completed", "done"])'),
})

export type PollingConfiguration = z.infer<typeof PollingConfigurationSchema>

export const PollingStateSchema = z.object({
  lastPollTimestamp: z.iso.datetime(),
  pollAttemptCount: z.number().int().nonnegative(),
  nextScheduledPollTime: z.iso.datetime(),
  pollingPropertyValue: z.unknown().optional(),
})
